"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZeusGlobalLogistics = void 0;
exports.ZeusGlobalLogistics = {
    id: 'zeusGlobalLogistics',
    companyName: 'Zeus Global Logistics',
    transportModes: ['sea'],
    freightGate: {
        isOnboarded: true,
        realm: 'zeusGlobalLogistics',
    },
    isInternal: false,
    isActive: true,
    countries: ['AU'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiWmV1c0dsb2JhbExvZ2lzdGljcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hZ2VudHMvZGF0YS9aZXVzR2xvYmFsTG9naXN0aWNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsbUJBQW1CLEdBQVU7SUFDdEMsRUFBRSxFQUFFLHFCQUFxQjtJQUN6QixXQUFXLEVBQUUsdUJBQXVCO0lBQ3BDLGNBQWMsRUFBRSxDQUFDLEtBQUssQ0FBQztJQUN2QixXQUFXLEVBQUU7UUFDVCxXQUFXLEVBQUUsSUFBSTtRQUNqQixLQUFLLEVBQUUscUJBQXFCO0tBQy9CO0lBQ0QsVUFBVSxFQUFFLEtBQUs7SUFDakIsUUFBUSxFQUFFLElBQUk7SUFDZCxTQUFTLEVBQUUsQ0FBQyxJQUFJLENBQUM7Q0FDcEIsQ0FBQSJ9